module.exports = __webpack_public_path__ + "static/media/ic_facebook.2e74e896.svg";